import { put, select, takeLatest } from 'redux-saga/effects'
import { getSceneDescriptionSelector } from '../selectors'
import { ISceneDescriptionState } from '../store/sceneDescription.types'
import { SceneDescriptionConstants } from '../store/sceneDescription.constants'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import { ISceneDescriptionOptionsState } from '../../options/store/options.types'
import { getSceneDescriptionOptionsSelector } from '../../options/selectors'
import {
  closeFirstOnSceneMessage,
  saveSceneDescriptionState,
  setOtherAgencies,
} from '../store/sceneDescription.actions'

export function* updateFirstOnScene() {
  const { otherAgencies, firstOnSceneKey }: ISceneDescriptionState = yield select(getSceneDescriptionSelector)
  const { firstOnSceneOptions }: ISceneDescriptionOptionsState = yield select(getSceneDescriptionOptionsSelector)

  const yesOption = firstOnSceneOptions.find((option) => option.id === 1)
  const noOption = firstOnSceneOptions.find((option) => option.id === 0)

  if (!yesOption || !noOption) return

  const updatedOtherAgencies = otherAgencies.map((otherAgency) => {
    if (otherAgency.key === firstOnSceneKey) {
      return {
        ...otherAgency,
        firstOnScene: yesOption,
      }
    } else if (otherAgency.firstOnScene?.name === 'Yes') {
      return {
        ...otherAgency,
        firstOnScene: noOption,
      }
    }
    return otherAgency
  })

  yield put(setOtherAgencies(updatedOtherAgencies))
  yield put(closeFirstOnSceneMessage())
  yield put(saveSceneDescriptionState())
}

export function* updateFirstOnSceneSaga() {
  yield takeLatest([SceneDescriptionConstants.UPDATE_FIRST_ON_SCENE], performWithMutexHOG, updateFirstOnScene)
}
